

export enum NasoLabialFoldType {
    None, Subtle, Cherubic, Nimoy, Meaney, Lewis
}
